import { linkedDefIds, TRADERS, traderSells } from "@rietz/shared";
// TYPE-ONLY, so the cycle with `inventory/menu.tsx` is not one at runtime.
import type { MenuEntry } from "../inventory/menu.js";
import { openMarket } from "../store.js";

/**
 * THE TWO WAYS FROM AN ITEM TO THE MARKET: "Filter by item" (this def alone, at
 * every counter that stocks it) and "Linked search" (everything one hop away
 * via `linkedDefIds` — a rifle's cartridges and furniture, a magazine's
 * ammunition). ABSENT RATHER THAN DISABLED when nothing is behind them (the
 * menu's rule): the first needs somebody to sell the def, the second at least
 * one linked def on a shelf. Not offered in a raid — the callers gate on `place
 * === "menu"`.
 */

/**
 * Whether anybody stocks `defId` — the market has a row per (trader, offer), so
 * this is "the market has a row for it".
 */
export function sold(defId: string): boolean {
  return TRADERS.some((trader) => traderSells(trader, defId));
}

/** The market's two entries for `defId`, in that order, with the ones that would
 *  open an empty list left out. */
export function marketEntries(defId: string): readonly MenuEntry[] {
  const entries: MenuEntry[] = [];
  if (sold(defId)) {
    entries.push({
      label: "Filter by item",
      run: () => {
        openMarket("item", defId);
      },
    });
  }
  if (linkedDefIds(defId).some(sold)) {
    entries.push({
      label: "Linked search",
      run: () => {
        openMarket("linked", defId);
      },
    });
  }
  return entries;
}
